export default "__VITE_ASSET__ybIYISVg__"